import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Punishment} from "../../../entities/players/Punishment";

@Component({
  selector: 'app-rank-dialogue',
  templateUrl: './quash-dialogue.component.html',
  styleUrls: ['./quash-dialogue.component.css']
})
export class QuashDialogueComponent {
  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<QuashDialogueComponent>,
              @Inject(MAT_DIALOG_DATA) public punishment: Punishment) {

  }

  no() {
    this.dialogRef.close();
  }
}
